import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import _ from 'underscore';

import DatabaseService from 'services/DatabaseService.js';
import Utils from 'utils/Utils.js';
import {SET_LOADING_OVERLAY_ENABLE} from 'actions/types';

import {Button, Modal, Header, Input, Message, Label} from 'semantic-ui-react';
import {colors, fontSizes, spacings, shadow, buttons} from 'style';
import styleDef from './style.js';

var style = {
    ...styleDef,
    star: {
        color:colors.themeBlue,
        position: 'relative',
        top: '2px',
    },
};

const TangoAccountModal = ({t, 
                          value, 
                          valid,
                          onChange, 
                          onClose, 
                          onSubmit}) => (
    <Modal open style={style.content} onClose={onClose} size='tiny'>
        <Modal.Header>{t('tangoaccount_modal_header')}</Modal.Header>
        <Modal.Content>
        <form onSubmit={onSubmit}>
            <Modal.Description>
                <div style={style.description}>{Utils.endlToBr(t('tangoaccount_modal_description'))}</div>
                <br />
                <Input labelPosition='left' type='text' value={value} onChange={onChange} />
                <br />
                <br />
                <Button type='submit' style={style.button} disabled={!valid}>{t('tangoaccount_modal_btn')}</Button>
            </Modal.Description>
        </form>
        </Modal.Content>
    </Modal>
);

class TangoAccountModalContainer extends Component {
    constructor(props) {
        super(props);
        var initialValue = this.props.value;
        this.state = { value:initialValue, valid:this.isValid(initialValue), complete:false };
        this.onSubmit = this.onSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
        
    }

    onSubmit(event) {
        event && event.preventDefault();
        this.props.dispatch({type: SET_LOADING_OVERLAY_ENABLE, enable:true});

        var data = {tangoAccountName: (this.state.value === '') ? null : this.state.value};
        DatabaseService.updateRewardsPlugin(data)
            .then(result => {
            })
            .catch(error => {
                console.error(error);
            })
            .then(()=>{
                this.props.onRefresh && this.props.onRefresh();
                this.props.onClose();
                this.props.dispatch({type: SET_LOADING_OVERLAY_ENABLE, enable:false});
            });
    }

    onChange = (event) => {
        var value = event.currentTarget.value;
        var valid = this.isValid(value);
        this.setState({value, valid});
    }

    isValid(value) {
        if(value>'') return true;
        return false
    }

    render() {
        return (
                   <TangoAccountModal {...this.props}
                                      value={this.state.value}
                                      valid={this.state.valid}
                                      complete={this.state.complete}
                                      onSubmit={this.onSubmit}
                                      onChange={this.onChange} />
             );
    }
}

export default connect()(withTranslation('rewards')(TangoAccountModalContainer));